// extracted by mini-css-extract-plugin
export var orderDetails = "_r2-2";
export var orderImage = "_r2-1";
export var orderMeta = "_r2-3";
export var orderSummary = "_r2-0";
export var rightArrow = "_r2-4";